import { createWebHistory, createRouter } from "vue-router";
import loginComponent from "../components/loginComponent.vue";
import signUp from "../components/signUp.vue";
import HomeView from "../views/HomeView.vue";
import createAutomation from "../components/connectorApp/CreateAutomation.vue";
import SettingsPage from "../components/SettingsPage.vue";
import profileBody from "../components/profileBody.vue";
import forgotPassword from "../components/forgotPassword.vue";
import forgotPasswordVerification from "../components/forgotPasswordVerification.vue";
import workflowsTable from "@/components/connectorApp/workflowsTable";
import ConfigureWorkflow from "@/components/connectorApp/ConfigureWorkflow";
import redirectUrl from "@/components/connectorApp/redirectUrlComponent";
import integrationRedirectComponent from "@/components/integrations/integrationRedirectComponent.vue";
import flowLogs from "@/components/connectorApp/flowLogs";
import ssouserLogin from "@/components/sso/ssoRedirect.vue";
import integrationsSetUp from "@/components/integrations/integrationsSetUp.vue";
import createAutomationWithAI from "@/components/connectorApp/createAutomationWithAI.vue";

// import integrationsOauthApplications from "@/components/integrations/integrationsOauthApplications.vue";
// import integrationsNonOauthApplications from "@/components/integrations/integrationsNonOauthApplications.vue";
import navigationComponent from "@/components/integrations/navigationComponent.vue";

const routes = [
  {
    name: loginComponent,
    path: "/",
    component: loginComponent,
  },
  {
    name: redirectUrl,
    path: "/connector/callback",
    component: redirectUrl,
  },
  {
    name: integrationRedirectComponent,
    path: "/integrations/callback",
    component: integrationRedirectComponent,
  },
  {
    name: signUp,
    path: "/signup",
    component: signUp,
  },
  {
    path: "/forgotPassword",
    name: "forgotPassword",
    component: forgotPassword,
  },
  {
    path: "/forgotPasswordVerification",
    name: "forgotPasswordVerification",
    component: forgotPasswordVerification,
  },
  {
    path: "/connector/workflow/:automationFlowId/:actionId?/:step?/:tab?",
    name: "workflow",
    component: ConfigureWorkflow,
    meta: {
      title: "Workflow",
    },
  },

  //to get the topbar and sidebar(below)
  {
    name: HomeView,
    path: "/home-view",
    component: HomeView,
    children: [
      {
        path: "/SettingsPage",
        name: "SettingsPage",
        component: SettingsPage,
      },
      {
        path: "/profileBody",
        name: "profileBody",
        component: profileBody,
      },
      {
        path: "/connector/all-workflows",
        name: "workflowsTable",
        component: workflowsTable,
      },
      {
        path: "/connector/flowLogs",
        name: "flowLogs",
        component: flowLogs,
      },
      {
        path: "/connector",
        name: "create-automation",
        component: createAutomation,
        meta: {
          title: "Create Automation",
        },
      },
    ],
  },
  {
    path: "/sso-signIn",
    name: "ssouserLogin",
    component: ssouserLogin,
    meta: {
      title: "ssouserLogin",
    },
  },
  {
    path: "/all-integrations",
    name: "integrationsSetUp",
    component: integrationsSetUp,
  },
  {
    path: "/create-with-AI",
    name: "createAutomationWithAI",
    component: createAutomationWithAI,
  },
  {
    path: "/integrations",
    name: "navigateToApplication",
    component: navigationComponent,
  },
  {
    path: "/developer",
    name: "settings",
    component: navigationComponent,
  },
];
const router = createRouter({
  history: createWebHistory(),
  routes,
});
export default router;
